export default __webpack_public_path__ + "static/media/WhiteLogo.51acd06f.png";